import MessageToast from "sap/m/MessageToast";
import Popup from "sap/ui/core/Popup";

export function ShowMessageToast(message: string): void {
  MessageToast.show(message, {
    at: Popup.Dock.RightTop as unknown as typeof Popup.Dock,
    my: Popup.Dock.RightTop as unknown as typeof Popup.Dock,
    offset: "-40 40",
  });
}
